var map = {
	"./images/back.png": 987,
	"./images/background.jpg": 988,
	"./images/bonus-circle.png": 989,
	"./images/bonus-head.png": 990,
	"./images/bonus-star.png": 991,
	"./images/effect-06.gif": 992,
	"./images/home.png": 993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 986;